<template>
    <section>
        <div class="news_box">
            <div class="title">思银股份携手火币中国打造“区块链+能源供应链”项目启动会</div>
            <p class="time">2018年12月17日</p>
            <p class="author">来源：火币中国</p>
            <div class="img_box1">
                <img src="../../assets/newActive/火币中国大图.png" alt="">
            </div>
            <div class="part1"><span style="padding-left:28px;"></span>2018年12月17日思银股份与火币中国就“海马能源供应链”达成战略合作，双方将共同推进区块链技术在能源供应链领域的落地应用。</div>
            <div class="img_box2">
                <img src="../../assets/newActive/火币中国大图2.jpeg" alt="">
            </div>
            <div class="part2"><span style="padding-left:28px;"></span>思银股份成立于2004年，2017年公司实现销售收入2.89亿，同比增加 32.71%。思银股份自确立打造互联网金融平台的战略目标以来，成功打造了覆盖全成品油产业链的服务平台，在全国多地的民营加油站均有业务合作，并且借助超过80多家银行的合作资源开展供应链金融业务。此次合作双方将依托各自领域优势，合力推动区块链在民营加油站的用户增长，智能服务平台、油品溯源以及油品供应链金融等领域的落地。预计2019年3月份将正式落地使用，届时将成为我国领先的“区块链+能源供应链”解决方案。</div>
        </div>
    </section>
</template>
<script>
    export default {
        
    }
</script>
<style scoped>
    .news_box{
        width: 1000px;
        margin: 0 auto;
    }
    .title{
        margin-top: 24px;
        padding-bottom: 24px;
        font-size: 28px;
    }
    .time, .author{
        margin-top: 12px;
    }
    .author{
        margin-bottom: 24px;
    }
    .part1, .part2{
        text-align: left;
        font-size: 14px;
        margin: 24px 0;
    }
    .img_box2 img{
        width: 96%;
    }
</style>
